import type { IHomeLoanReviewProductFee } from './HomeLoanReviewProductFee.interface';

export default class HomeLoanReviewProductFee implements IHomeLoanReviewProductFee {
  application: number;
  valuation: number;
  legal: number;
  settlement: number;
  packageMonthly: number;
  packageAnnual: number;
  rateLock: number;
  other: number;

  static build = (data: IHomeLoanReviewProductFee) => new HomeLoanReviewProductFee(data);
  static blank = () => new HomeLoanReviewProductFee();

  /**
   * Constructor
   * @param {IHomeLoanReviewProductFee} data
   */
  constructor(data?: IHomeLoanReviewProductFee) {
    this.application = parseFloat(data?.application || 0);
    this.valuation = parseFloat(data?.valuation || 0);
    this.legal = parseFloat(data?.legal || 0);
    this.settlement = parseFloat(data?.settlement || 0);
    this.packageMonthly = parseFloat(data?.packageMonthly || 0);
    this.packageAnnual = parseFloat(data?.packageAnnual || 0);
    this.rateLock = parseFloat(data?.rateLock || 0);
    this.other = parseFloat(data?.other || 0);
  }
}
